import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function DashboardShell({ role, accent, navItems, children, testid }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid={testid}>
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Sidebar */}
        <aside className="lg:w-64 shrink-0">
          <div className="bg-card border border-border rounded-2xl p-4 lg:sticky lg:top-24">
            <div className="flex items-center gap-2 px-2 pb-4 mb-2 border-b border-border">
              <span className="grid place-items-center w-8 h-8 rounded-lg bg-primary text-primary-foreground">
                <Home size={16} />
              </span>
              <div>
                <p className="font-heading text-sm font-semibold leading-tight">{role}</p>
                <p className="text-xs text-muted-foreground">Dashboard</p>
              </div>
            </div>
            <nav className="space-y-1">
              {navItems.map((item, i) => (
                <button
                  key={item}
                  data-testid={`dash-nav-${i}`}
                  className={`w-full text-left px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                    i === 0 ? "bg-secondary text-primary" : "text-muted-foreground hover:bg-secondary/60"
                  }`}
                >
                  {item}
                </button>
              ))}
            </nav>
          </div>
        </aside>

        {/* Content */}
        <div className="flex-1 min-w-0">{children}</div>
      </div>
    </div>
  );
}

export function PlaceholderNotice({ title, description }) {
  return (
    <div className="mt-6 rounded-2xl border border-dashed border-border bg-secondary/30 p-10 text-center" data-testid="placeholder-notice">
      <h3 className="font-heading text-lg font-medium text-foreground">{title}</h3>
      <p className="mt-2 text-sm text-muted-foreground max-w-md mx-auto leading-relaxed">{description}</p>
      <span className="mt-4 inline-block text-xs font-bold uppercase tracking-[0.2em] text-primary">
        Segera Hadir
      </span>
    </div>
  );
}

export function MetricCard({ label, value, hint, index = 0, testid }) {
  return (
    <div
      className="bg-card border border-border rounded-xl p-5 hover:-translate-y-0.5 transition-transform"
      data-testid={testid || `metric-card-${index}`}
    >
      <p className="text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground">{label}</p>
      <p className="mt-2 font-heading text-3xl font-bold text-foreground" data-testid={testid ? `${testid}-value` : undefined}>{value}</p>
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}
